const toSegments = (version: string): number[] =>
  version.split('.').map((segment) => Number.parseInt(segment, 10) || 0);

export const compareVersion = (a: string, b: string): number => {
  const aSegments = toSegments(a);
  const bSegments = toSegments(b);
  const length = Math.max(aSegments.length, bSegments.length);

  const firstDifference = Array.from(
    { length },
    (_, index) => (aSegments[index] ?? 0) - (bSegments[index] ?? 0),
  ).find((difference) => difference !== 0);

  return firstDifference ?? 0;
};
